if (document.getElementById('helpSelector')) {
    Vue.use(window.vuelidate.default);
    var { required, email, minLength, helpers } = window.validators;
    const referenceIdCheck = (value) => /(^ENQ)([ -])?(\d)[0-9]{1,7}$|(^INC)([ -])?(\d)[0-9]{1,7}$/.test(value.toUpperCase().replace(/\s/g, ''))

    var formQA = new Vue({
        el: '#helpSelector',
        data: () => ({
            loading: false,
            helpSelector: '',
            showTicket: "showQueryTicket",
            ticket: {
                ticketReferenceID: qsReferenceID,
                ticketEmail: qsEmail
            },
            responseHasError: false,
            emailHasError: false,
            referenceIdHasError: false,
            responseData: null
        }),
        validations: {
            ticket: {
                ticketReferenceID: {
                    required,
                    referenceIdCheck,
                    minLength: minLength(5)
                },
                ticketEmail: {
                    required,
                    email
                },
            }
        },
        mounted() {
            var self = this;
            self.loading = false;
            this.$v.$reset();
            this.ticket.ticketReferenceID = '';
            this.ticket.ticketEmail = '';
            $('#helpSelector').removeClass('d-none');
            window.history.replaceState(null, document.title, window.location.href.split("?")[0]);
            window.onpopstate = function (event) {
                const url = window.location.href.split("?")[0];

                if (url == window.location.href || event.state == null || (event.state.path && !event.state.path.indexOf('checkStatus') >= 0)) {
                    window.history.replaceState(null, document.title, url);
                    self.showTicket = false;
                    self.helpSelector = '';
                    self.ticket.ticketEmail = '';
                    self.ticket.ticketReferenceID = '';
                    self.responseHasError = false;
                }
            };
        },
        methods: {
            otherTicket() {
                this.$v.$reset();
                this.showTicket = 'showQueryTicket';
                this.ticket.ticketReferenceID = '';
                this.ticket.ticketEmail = '';
                this.responseData = null;
                this.referenceIdHasError = false;
                this.emailHasError = false;
                this.responseHasError = false;
                window.location.href = "/help-and-support/check-status-of-an-existing-support-request/";
                //if (history.pushState) {
                //    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?checkStatus';
                //    window.history.pushState({ path: newurl }, '', newurl);
                //};
                scrollToElement('body');
            },
            next() {
                this.$v.$reset();
                this.referenceIdHasError = false;
                this.emailHasError = false;
                switch (this.helpSelector) {
                    case 'showCustomer': window.location.href = "/help-and-support/raise-a-new-support-request/reason-of-query/";
                        break;
                    case 'showGasCustomer': window.location.href = "/help-and-support/raise-a-new-support-request/question-answer?query-type=gas-consumer";
                        break;
                    case 'showTicket': {
                        this.showTicket = "showQueryTicket";
                        if (!window.location.search.indexOf('checkStatus') >= 0) {
                            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?checkStatus';
                            window.history.pushState({ path: newurl }, '', newurl);
                        }
                    }
                        break;
                    case 'showTicketQuery': this.showTicket = 'showTicketQuery'
                }
                scrollToElement('body')
            },
            sendTicket() {
                const self = this;
                this.$v.$reset();
                this.$v.ticket.$touch();
                //this.responseHasError = false;
                if (this.$v.ticket.$invalid) {
                    scrollToElement('h4.section-title');
                    return false;
                } else {
                    if (this.ticket.ticketReferenceID.toUpperCase().indexOf('ENQ') == 0) {
                        self.loading = true;
                        axios.post('/umbraco/api/ContactApi/CheckTicketStatus', {
                            referenceID: this.ticket.ticketReferenceID.toUpperCase(),
                            email: this.ticket.ticketEmail
                        })
                        .then(function (response) {
                            self.responseData = response.data;
                            if (!self.responseData.MPRN) {
                                self.responseData.MPRN = "N/A"
                            }
                            if (response.data.ResponseCode == 200) {
                                self.showTicket = 'showTicketQuery';
                                if (history.pushState) {
                                    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?ReferenceID=" + self.ticket.ticketReferenceID + "&Email=" + self.ticket.ticketEmail;
                                    window.history.pushState({ path: newurl }, '', newurl);
                                }
                                self.ticket.ticketEmail = '';
                                self.ticket.ticketReferenceID = '';
                            } else {
                                self.responseHasError = true
                            }
                            self.loading = false;
                        })
                        .catch(function (error) {
                            self.loading = false;
                            console.log(error);
                            return false;
                        })
                            .finally(function () { scrollToElement('#ticketSection') })
                    } else {
                        self.loading = false;
                        let refNumber = self.ticket.ticketReferenceID.toUpperCase().replace(/[\. ,:-]+/g, "");
                        window.location.href = 'https://servicedesk.xoserve.com/Portal/Checkstatus.xhtml?T=' + refNumber+'&E=' + self.ticket.ticketEmail;
                    }
                }
            }

        },
        computed: {          
            errorMsg() {
                if (this.responseData != null && this.responseData.ResponseCode == 406) {
                    if (this.responseData.ResponseMessage == "The given reference ID is wrong") {
                        this.referenceIdHasError = true;
                        return validationMessageApiErrorReference;
                    } else {
                        this.emailHasError = true;
                        return validationMessageApiErrorEmail;
                    }
                } else {
                return ''
                }
            }
        },
    }) 
}
